import { Component, NgZone } from '@angular/core';
import { GlobalConstants } from '../../global-constants';
import { QueryService } from '../../comun/services/query.service';
import { FuncionesService } from '../../comun/services/funciones.service';
import Swal from 'sweetalert2';
import { LoaderService } from '../../comun/services/loader.service';
import { jwtDecode, JwtPayload } from "jwt-decode";
import { BehaviorSubject } from 'rxjs';
declare const google: any;

export interface GoogleUser {
  sub: string;            // ID único del usuario en Google
  email: string;
  email_verified: boolean;
  name: string;
  picture: string;
  given_name: string;
  family_name: string;
  iat: number;
  exp: number;
}

@Component({
  selector: 'app-perfil-opciones',
  templateUrl: './perfil-opciones.component.html',
  styleUrl: './perfil-opciones.component.css'
})
export class PerfilOpcionesComponent {
  misdatos: any = {};
  busy: number = 0;
  opciones = {
    privacidad: {
      perfilPublico: true
    },
    seguridad: {
      cambiarContrasena: false,
      password_actual: '',
      password_nueva: '',
      password_confirmacion: ''
    }
  };
  private userSubject = new BehaviorSubject<any>(null);
  rol_perfil: string = '';
  roles: any[] = [];
  rol: any = {};
  modificar: boolean = false;

  constructor(public query: QueryService, 
              public funciones: FuncionesService, 
              private ngZone: NgZone,
              public loader: LoaderService) {}

  ngOnInit() {
    this.getMisDatos();
  }

  getMisDatos() {
    ++this.busy;
    this.query.query('misdatos', 'GET', { ID: 0 }).subscribe((resultado:any) => {      
      this.misdatos = resultado;      
      this.rol_perfil = this.misdatos.rol_perfil;
      if (this.rol_perfil == '')
        this.modificar = true;
      this.getRoles();
      --this.busy;
      // Establecer el estado del perfil público según el rol del usuario
      this.opciones.privacidad.perfilPublico = (this.misdatos.rol == 'no_publico') ? false : true;
    });
  }

  ngAfterViewInit(): void {
    const interval = setInterval(() => {
      if (typeof google !== 'undefined') {
        clearInterval(interval);

        google.accounts.id.initialize({
          client_id: '934921995714-9r5vnan638c8d3s495mfnebq5pgrl5e6.apps.googleusercontent.com',
          callback: (response: any) => this.handleCredentialResponse(response)
        });

        google.accounts.id.renderButton(
          document.getElementById("google-btn"),
          { theme: "outline", size: "large" }  // opciones de estilo
        );

      }
    }, 100);
  }

  cambiarContrasena() {
    if (this.opciones.seguridad.cambiarContrasena) {
      if (this.funciones.validarContrasena(this.opciones.seguridad.password_nueva) == false) {
        Swal.fire({
          title: 'Contraseña no válida',  
          text: 'La contraseña debe tener entre 8 y 48 caracteres, incluir al menos una letra minúscula, una letra mayúscula y un número.',
          icon: 'error',
          confirmButtonText: 'Aceptar'
        });
        return;
      }
      this.loader.show();
      this.query.query('misdatos', 'CAMBIARPASSWORD', { password_actual: this.opciones.seguridad.password_actual, password_nueva: this.opciones.seguridad.password_nueva, password_confirmacion: this.opciones.seguridad.password_confirmacion }).subscribe((resultado:any) => {
        this.loader.hide();
        if (resultado.resultado == 'OK') {
          Swal.fire({
            title: 'Contraseña cambiada',
            text: 'Tu contraseña ha sido cambiada correctamente.',
            icon: 'success',
            confirmButtonText: 'Aceptar'
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            title: 'Error',
            text: resultado.mensaje,
            icon: 'error',
            confirmButtonText: 'Aceptar'
          });
          this.opciones.seguridad.password_actual = '';
          this.opciones.seguridad.password_nueva = '';
          this.opciones.seguridad.password_confirmacion = '';
        }
      });
    }
    this.opciones.seguridad.cambiarContrasena = !this.opciones.seguridad.cambiarContrasena;
  }

  cancelarContrasena() {
    this.opciones.seguridad.cambiarContrasena = false;
    this.opciones.seguridad.password_actual = '';
    this.opciones.seguridad.password_nueva = '';
    this.opciones.seguridad.password_confirmacion = '';
  }
  
  desactivarCuenta() {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres desactivar tu cuenta?',
      //icon: 'warning',
      imageUrl: GlobalConstants.urlServer + 'img/smilesad.png',
      imageWidth: 150,
      imageHeight: 150,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.show();
        this.query.query('misdatos', 'DESACTIVAR', null).subscribe((resultado:any) => {
          this.loader.hide();
          window.location.href = GlobalConstants.urlServer;
        });
      } else {
      }
    });
  }

  eliminarCuenta() {
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres eliminar tu cuenta? Esta acción no se puede deshacer.',
      //icon: 'warning',
      imageUrl: GlobalConstants.urlServer + 'img/smilesad.png',
      imageWidth: 150,
      imageHeight: 150,
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-swal-confirm',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loader.show();
        this.query.query('misdatos', 'BAJA', null).subscribe((resultado:any) => {
          // Enviar email a los administradores
          let contenido = '<p>Hola equipo,</p>' +
                          '<p>Se ha dado de baja el usuario ID: ' + this.misdatos.ID + ' en iGuau.</p>' +
                          '<p>Correo electrónico: <b>' + this.misdatos.email + '</b></p>' +
                          '<p>Un saludo,<br>El equipo de iGuau</p>';
          let params = { plantilla: 'general.html',
                        us_id: 0, // administradores
                        tipo: 'ACTIVIDAD',
                        asunto: 'Baja de usuario en iGuau',
                        contenido: contenido,
                        botonurl: GlobalConstants.urlWeb + '/wp-admin/',
                        boton: 'Panel de control',
                        estado: 'enviado',
                        contacto: '' // al email de contacto del usuario
                      };
          this.query.enviarMail(params).subscribe((resultado:any) => {
          });

          window.location.href = GlobalConstants.urlServer;
        });
      } else {
      }
    });
  }

  guardarCambios() {
    // Guardar cambios de privacidad
    let rol = this.opciones.privacidad.perfilPublico ? 'publico' : 'no_publico';
    this.loader.show();
    this.query.query('misdatos', 'ROLPUBLICO', { perfilPublico: rol }).subscribe((resultado:any) => {
      this.subirScroll();
      this.volverPerfil();
    });
  }
  
  volverPerfil() {
    window.location.href = GlobalConstants.urlServer + 'perfil';
  }

  subirScroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  handleCredentialResponse(response: any) {
    this.ngZone.run(() => {
      // Aquí recibes el JWT de Google
      const token = response.credential;
      // Guardar el token en localStorage
      localStorage.setItem('google_token', token);

      const user: GoogleUser = jwtDecode<GoogleUser>(token);
      this.ngZone.run(() => {
        this.userSubject.next(user);
        // Guardar en localStorage para compartir entre proyectos
        localStorage.setItem('googleUser', JSON.stringify(user));
      });

      this.query.query('misdatos', 'VINCULAR_GOOGLE', { google_sub: user.sub }).subscribe((resultado:any) => {      
        this.misdatos.login_provider = 'google';
        Swal.fire({
          title: 'Cuenta vinculada',
          text: 'Tu cuenta ha sido vinculada con Google correctamente.',
          icon: 'success',
          confirmButtonText: 'Aceptar'
        }).then(() => {
          window.location.reload();
        });
      });
    });
  }

  getRoles() {
    this.query.query('valores', 'GET', { grupo: 'ROL' }).subscribe((resultado:any) => {      
      this.roles = resultado.registros;
      this.getRolPerfil();
    });
  }

  getRolPerfil() {
    this.rol = this.roles.find(r => r.va_id == this.rol_perfil);
  }

  cambioPerfil() {
    this.modificar = !this.modificar;
  }

  modificarPerfil(rol: string) {
    //this.rol_perfil = rol;
    this.query.query('misdatos', 'CAMBIARROLPERFIL', { rol_perfil: rol }).subscribe((resultado:any) => {
      this.guardarCambios();
    });
  }
}
